import {NavbarLogo} from '../../utils/allImgs'

export const Logo = NavbarLogo;

export const MenuInfo = [
	{
		path:"#home",
		nameLink:'Home'
	},
	{
		path:"#about",
		nameLink:'About'
	},
	{
		path:"#services",
		nameLink:'Services'
	},
	{
		path:"#roadmap",
		nameLink:'Roadmap'
	},
	{
		path:"#team",
		nameLink:'Team'
	},
	{
		path:"#contact",
		nameLink:'Contact'
	}
]